import './RemovedListsModal.scss';
import Text from '@ingka/text';

import { useLoading } from '../../../hooks/useLoading';
import Button from '../../Skapa/Button/Button';
import { PREFIX } from '../../Skapa/constants/constants';
import SkapaList from '../../Skapa/List/List';
import Modal, { ModalFooter, ModalHeader, Prompt } from '../../Skapa/Modal/Modal';

type Labels = {
  modal: {
    title: string;
    subtitle: string;
    body: string;
  };
  footer: {
    close: {
      label: string;
    };
  };
};
type List = {
  name: string;
};
enum LocalLoading {
  REMOVE = 'remove',
}
export interface RemovedListsModalProps {
  isOpen: boolean;
  labels: Labels;
  lists: List[];
  onClose: () => void;
}
export const RemovedListsModal = (props: RemovedListsModalProps) => {
  const { isOpen, labels, lists, onClose } = props;
  const localLoading = useLoading<LocalLoading>([]);

  return (
    <Modal visible={isOpen} handleCloseBtn={() => onClose()} scrollLock={false}>
      <Prompt
        titleId={labels.modal.title}
        title={labels.modal.title}
        header={<ModalHeader />}
        footer={
          <ModalFooter>
            <Button
              fluid={true}
              onClick={() => onClose()}
              text={labels.footer.close.label}
              loading={localLoading.check(LocalLoading.REMOVE)}
              type="primary"
            />
          </ModalFooter>
        }
      >
        <Text prefix={PREFIX} tagName="p" textStyle="Body.M" className="body">
          {labels.modal.body}
        </Text>
        <Text prefix={PREFIX} tagName="h4" textStyle="Heading.XS">
          {labels.modal.subtitle}
        </Text>
        {lists && (
          <SkapaList size="small">
            {lists.map((list) => (
              <li key={list.name}>{list.name}</li>
            ))}
          </SkapaList>
        )}
      </Prompt>
    </Modal>
  );
};
